module.exports = __webpack_public_path__ + "static/img/img-home-co-13.a98e7b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-13.png
// module id = tAm9
// module chunks = 1